/** @file CSS selector of the elements the Tab key can land on: enabled controls kept in the tab order. */

const CONTROLS = ['a[href]', 'button:not(:disabled)', 'input:not(:disabled):not([type="hidden"])', 'select:not(:disabled)', 'textarea:not(:disabled)', '[tabindex]'];

/** Selector list; every alternative drops tabindex="-1", so the inactive items of a roving-tabindex widget stay out of a Tab trap. */
export const focusableSelector = CONTROLS.map((control) => `${control}:not([tabindex="-1"])`).join(', ');
